import React, { useRef, useState } from 'react';
import { signup } from '../../util/APIUtils';
import { Link, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { error, success } from '../../util/toast';
import { allow2Oauth } from '../../constants/config';
import Select from 'react-select';
import SocialSignup from '../social-signup';
import { useQuery } from '../../common/hooks/useQuery';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { DEFAULT_REDIRECT_URI } from '../../constants';
import showPass from '../../assets/img/showPass.svg';
import hidePass from '../../assets/img/hidePass.svg';

import useIsTouchDevice from '../../common/hooks';

const PersonalForm = (props) => {
  const { i18n } = useLingui();
  let history = useHistory();
  const { data, lang, redirectParam } = props;
  const { fields } = data;
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    watch,
  } = useForm();

  const query = useQuery();
  const password = useRef({});
  password.current = watch('password', '');

  const [selectedFields, setSelectedFields] = useState([]);

  const onSubmit = (data) => {
    console.log(data);
    delete data.repassword;
    if (!data.lastName || data.lastName === '') {
      setError('lastName', 'Bạn chưa nhập họ');
      return;
    }
    if (!data.firstName || data.firstName === '') {
      setError('lastName', 'Bạn chưa nhập tên');
      return;
    }
    if (!data.myCheckbox || data.myCheckbox === false) {
      setError('myCheckbox', 'Bạn phải đồng ý với điều khoản và điều kiện!');
      return;
    }
    delete data.myCheckbox;

    data.listFieldsId = selectedFields.map((item) => {
      return item.value;
    });
    const obj = {
      registerAccountDTO: data,
      bothRegister: false,
    };
    signup(obj)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error();
        }
        success(<Trans>Đăng ký thành công , vui lòng đăng nhập</Trans>);
        setTimeout(() => {
          history.push(
            `/login${redirectParam ? `?redirect=${redirectParam}` : ''}`,
          );
        }, 500);
      })
      .catch((err) => {
        error(
          (err && err.detail) || (
            <Trans>Trùng thông tin với tài khoản đã có trong hệ thống</Trans>
          ),
        );
      });
  };
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const [rePasswordShown, setRePasswordShown] = useState(false);

  const isTouchDevice = useIsTouchDevice();

  const toggleRePasswordVisiblity = () => {
    setRePasswordShown(rePasswordShown ? false : true);
  };
  return (
    <div>
      {!isTouchDevice ? (
        <div className="block">
          <div className="content-register">
            <div
              className=" mb-6"
              style={{ fontWeight: 'bold', fontSize: '36px', color: '#FFF' }}
            >
              <Trans> Đăng ký tài khoản cá nhân</Trans>
            </div>
            <div className="h-1 mb-8 bg-white" style={{ width: '59px' }}></div>
            <div
              className="font-bold text-white mb-3"
              style={{ fontSize: '22px' }}
            >
              <Trans>Thông tin tài khoản</Trans>
            </div>
            <div className="">
              <form
                id="formSignUp"
                method="post"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="md:flex w-full mb-2">
                  <div className="md:w-1/2 md:pr-5">
                    <div className="md:flex">
                      <div className="md:mr-2 w-full">
                        <span className="block mb-2 text-sm text-white">
                          <Trans>Họ</Trans>
                        </span>
                        <input
                          type="text"
                          id="lastName"
                          className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                          name="lastName"
                          placeholder={i18n._(`Họ`)}
                          {...register('lastName', {
                            required: i18n._(`Vui lòng điền họ`),
                          })}
                        />
                        <span className="block efname text-red-500 text-xs">
                          {errors.lastName?.message}
                        </span>
                      </div>
                      <div className="md:ml-2 w-full">
                        <span className="block mb-2 text-sm text-white">
                          <Trans>Tên</Trans>
                        </span>
                        <input
                          type="text"
                          id="firstName"
                          className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                          name="firstName"
                          placeholder={i18n._(`Tên`)}
                          {...register('firstName', {
                            required: i18n._(`Vui lòng điền tên`),
                          })}
                        />
                        <span className="block text-red-500 text-xs">
                          {errors.firstName?.message}
                        </span>
                      </div>
                    </div>
                    <div>
                      <span className="block text-sm text-white mb-2">
                        {' '}
                        Email
                      </span>
                      <input
                        type="email"
                        id="email"
                        className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                        name="email"
                        {...register('email', {
                          required: i18n._(`Email không được để trống`),
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: i18n._(`Email không đúng định dạng`),
                          },
                        })}
                        placeholder="Email"
                      />
                      <span className="block eemail text-red-500 text-xs">
                        {errors.email?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2 text-sm text-white">
                        <Trans> Lĩnh vực hoạt động</Trans>
                      </span>
                      <Select
                        isMulti
                        options={fields.map((item) => {
                          return {
                            value: item.id,
                            label: lang == 'vi-VN' ? item.nameVi : item.nameEn,
                          };
                        })}
                        onChange={(e) => setSelectedFields(e)}
                        name="listFieldsId"
                        id="linhvuc"
                        placeholder={i18n._(`Chọn lĩnh vực`)}
                        className="fields mb-4 w-full rounded"

                        // {...register('listFieldsId')}
                      />

                      <span className="block efields text-red-500 text-xs"></span>
                    </div>
                  </div>
                  <div className="md:w-1/2 md:pl-5">
                    <div>
                      <span className="block text-sm text-white mb-2">
                        <Trans>Tài khoản đăng nhập</Trans>
                      </span>
                      <input
                        type="text"
                        id="login"
                        className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                        name="login"
                        {...register('login', {
                          required: i18n._(`Tên đăng nhập không được để trống`),
                          pattern: {
                            value:
                              /^[a-zA-Z0-9]([._-](?![._-])|[a-zA-Z0-9]){0,18}[a-zA-Z0-9]$/i,
                            message: i18n._(
                              `Tên đăng nhập không đúng định dạng. Ví dụ: abc_1 abc-1 abc.1`,
                            ),
                          },
                        })}
                        placeholder={i18n._(`Tài khoản`)}
                      />
                      <span className="block text-red-500 text-xs">
                        {errors.login?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2 text-sm text-white">
                        <Trans>Mật khẩu</Trans>
                      </span>
                      <div className="relative flex">
                        <input
                          id="password"
                          className="w-full mb-4 border rounded py-1 px-3 border-gray-300"
                          name="password"
                          {...register('password', {
                            required: i18n._(`Vui lòng điền mật khẩu`),
                            minLength: {
                              value: 6,
                              message: t`Mật khẩu tối thiểu 6 ký tự`,
                            },
                          })}
                          placeholder={i18n._(`Mật khẩu`)}
                          type={passwordShown ? 'text' : 'password'}
                        />
                        <div
                          onClick={togglePasswordVisiblity}
                          className="absolute right-[13px] translate-y-1/3 -translate-x-1/2"
                        >
                          {passwordShown ? (
                            <img src={showPass} />
                          ) : (
                            <img src={hidePass} />
                          )}
                        </div>
                      </div>
                      <span className="block epassword text-red-500 text-xs">
                        {errors.password?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2 text-sm text-white">
                        <Trans>Mật khẩu xác nhận</Trans>
                      </span>
                      <div className="relative flex">
                        <input
                          id="repassword"
                          {...register('repassword', {
                            required: i18n._(`Không được để trống`),
                            validate: (value) =>
                              value === password.current ||
                              i18n._(`Mật khẩu không khớp`),
                          })}
                          className="w-full mb-4 mt-0.5 border rounded py-1 px-3 border-gray-300"
                          placeholder={i18n._(`Nhập lại mật khẩu`)}
                          type={rePasswordShown ? 'text' : 'password'}
                        />
                        <div
                          onClick={toggleRePasswordVisiblity}
                          className="absolute right-[13px] translate-y-1/3 -translate-x-1/2"
                        >
                          {rePasswordShown ? (
                            <img src={showPass} />
                          ) : (
                            <img src={hidePass} />
                          )}
                        </div>
                      </div>
                      <span className="block erepassword text-red-500 text-xs">
                        {errors.repassword?.message}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex gap-x-1 items-start mb-1">
                  <input
                    type="checkbox"
                    id="myCheckbox"
                    name="myCheckbox"
                    className={`form-checkbox h-4 w-4 rounded-[3px] mt-0.5`}
                    {...register('myCheckbox', {
                      required: i18n._(
                        `Bạn phải đồng ý với điều khoản và điều kiện!`,
                      ),
                    })}
                  />
                  <div className="text-[#FFFFFF] font-medium text-[14px]">
                    Tôi đồng ý với các{' '}
                    <span className="underline">điều khoản và điều kiện</span>{' '}
                    của VINet
                  </div>
                </div>
                <span className="block efname text-red-500 text-xs mb-10">
                  {errors.myCheckbox?.message}
                </span>

                <div className="w-full flex justify-center mb-10">
                  <button
                    className="px-10 py-2 rounded text-white"
                    type="submit"
                    id="btnRegister"
                    style={{ backgroundColor: ' rgba(242, 111, 39, 1)' }}
                  >
                    <Trans>Đăng ký</Trans>
                  </button>
                </div>
                {allow2Oauth === true && (
                  <>
                    <div className={'lg:block md:hidden mx-auto pt-7 flex'}>
                      <SocialSignup
                        redirect={
                          query.get('redirect') || DEFAULT_REDIRECT_URI + '/o/0'
                        }
                      />
                    </div>
                  </>
                )}

                <div className="sm:flex text-center w-full justify-center items-center mt-4">
                  <div className=" mr-3 text-white">
                    <Trans>Bạn đã có tài khoản ?</Trans>
                  </div>
                  <div>
                    <Link
                      to={`/login${
                        redirectParam ? `?redirect=${redirectParam}` : ''
                      }`}
                    >
                      <div className="text-white underline font-medium ">
                        <Trans>Nhấn vào đây để đăng nhập</Trans>
                      </div>
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="block">
          <div className="content-register">
            <div
              className=" mb-1"
              style={{ fontWeight: 'bold', fontSize: '26px', color: '#FFF' }}
            >
              <Trans> Đăng ký tài khoản cá nhân</Trans>
            </div>
            <div className="h-1 mb-4 bg-white" style={{ width: '59px' }}></div>

            <div className="">
              <form
                id="formSignUp"
                method="post"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="md:flex w-full mb-2">
                  <div className="md:w-1/2 md:pr-5">
                    <div className="md:flex">
                      <div className="md:mr-2 w-full">
                        <span className="block mb-2 font-medium text-white">
                          <Trans>Họ *</Trans>
                        </span>
                        <input
                          type="text"
                          id="lastName"
                          className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                          name="lastName"
                          placeholder={i18n._(`Nhập họ`)}
                          {...register('lastName', {
                            required: i18n._(`Vui lòng điền họ`),
                          })}
                        />
                        <span className="block efname text-[#EAA985] text-xs">
                          {errors.lastName?.message}
                        </span>
                      </div>
                      <div className="md:ml-2 w-full">
                        <span className="block mb-2 font-medium text-white">
                          <Trans>Tên *</Trans>
                        </span>
                        <input
                          type="text"
                          id="firstName"
                          className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                          name="firstName"
                          placeholder={i18n._(`Nhập tên`)}
                          {...register('firstName', {
                            required: i18n._(`Vui lòng điền tên`),
                          })}
                        />
                        <span className="block text-[#EAA985] text-xs">
                          {errors.firstName?.message}
                        </span>
                      </div>
                    </div>
                    <div>
                      <span className="block font-medium text-white mb-2">
                        {' '}
                        Email *
                      </span>
                      <input
                        type="email"
                        id="email"
                        className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                        name="email"
                        {...register('email', {
                          required: i18n._(`Email không được để trống`),
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: i18n._(`Email không đúng định dạng`),
                          },
                        })}
                        placeholder="Nhập email"
                      />
                      <span className="block eemail text-[#EAA985] text-xs">
                        {errors.email?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2 font-medium text-white">
                        <Trans> Lĩnh vực hoạt động</Trans>
                      </span>
                      <Select
                        isMulti
                        options={fields.map((item) => {
                          return {
                            value: item.id,
                            label: lang == 'vi-VN' ? item.nameVi : item.nameEn,
                          };
                        })}
                        onChange={(e) => setSelectedFields(e)}
                        name="listFieldsId"
                        id="linhvuc"
                        placeholder={i18n._(`Chọn lĩnh vực hoạt động`)}
                        className="fields mb-4 w-full rounded"

                        // {...register('listFieldsId')}
                      />

                      <span className="block efields text-[#EAA985] text-xs"></span>
                    </div>
                  </div>
                  <div className="md:w-1/2 md:pl-5">
                    <div>
                      <span className="block font-medium text-white mb-2">
                        <Trans>Tài khoản đăng nhập *</Trans>
                      </span>
                      <input
                        type="text"
                        id="login"
                        className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                        name="login"
                        {...register('login', {
                          required: i18n._(`Tên đăng nhập không được để trống`),
                          pattern: {
                            value:
                              /^[a-zA-Z0-9]([._-](?![._-])|[a-zA-Z0-9]){0,18}[a-zA-Z0-9]$/i,
                            message: i18n._(
                              `Tên đăng nhập không đúng định dạng. Ví dụ: abc_1 abc-1 abc.1`,
                            ),
                          },
                        })}
                        placeholder={i18n._(`Nhập tài khoản`)}
                      />
                      <span className="block text-[#EAA985] text-xs">
                        {errors.login?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2 font-medium text-white">
                        <Trans>Mật khẩu *</Trans>
                      </span>
                      <div className="relative flex">
                        <input
                          id="password"
                          className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                          name="password"
                          {...register('password', {
                            required: i18n._(`Vui lòng điền mật khẩu`),
                            minLength: {
                              value: 6,
                              message: t`Mật khẩu tối thiểu 6 ký tự`,
                            },
                          })}
                          placeholder={i18n._(`Nhập mật khẩu`)}
                          type={passwordShown ? 'text' : 'password'}
                        />
                        <div
                          onClick={togglePasswordVisiblity}
                          className="absolute right-[13px] translate-y-1/3 -translate-x-1/2"
                        >
                          {passwordShown ? (
                            <img src={showPass} />
                          ) : (
                            <img src={hidePass} />
                          )}
                        </div>
                      </div>
                      <span className="block epassword text-[#EAA985] text-xs">
                        {errors.password?.message}
                      </span>
                    </div>
                    <div>
                      <span className="block mb-2 font-medium text-white">
                        <Trans>Mật khẩu xác nhận *</Trans>
                      </span>
                      <div className="relative flex">
                        <input
                          id="repassword"
                          {...register('repassword', {
                            required: i18n._(`Không được để trống`),
                            validate: (value) =>
                              value === password.current ||
                              i18n._(`Mật khẩu không khớp`),
                          })}
                          className="w-full mb-1 border rounded py-1 px-3 border-gray-300"
                          placeholder={i18n._(`Nhập lại mật khẩu`)}
                          type={rePasswordShown ? 'text' : 'password'}
                        />
                        <div
                          onClick={toggleRePasswordVisiblity}
                          className="absolute right-[13px] translate-y-1/3 -translate-x-1/2"
                        >
                          {rePasswordShown ? (
                            <img src={showPass} />
                          ) : (
                            <img src={hidePass} />
                          )}
                        </div>
                      </div>
                      <span className="block erepassword text-[#EAA985] text-xs">
                        {errors.repassword?.message}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex gap-x-1 items-start mb-1">
                  <input
                    type="checkbox"
                    id="myCheckbox"
                    name="myCheckbox"
                    className={`form-checkbox h-4 w-4 rounded-[3px] mt-1`}
                    {...register('myCheckbox', {
                      required: i18n._(
                        `Bạn phải đồng ý với điều khoản và điều kiện!`,
                      ),
                    })}
                  />
                  <div className="text-[#FFFFFF] font-medium text-[14px]">
                    Tôi đồng ý với các{' '}
                    <span className="underline">điều khoản và điều kiện</span>{' '}
                    của VINet
                  </div>
                </div>
                <span className="block efname text-[#EAA985] text-xs mb-10">
                  {errors.myCheckbox?.message}
                </span>
                <div className="w-full flex justify-center mb-8">
                  <button
                    className="px-10 py-2 w-[270px] h-[48px] font-medium rounded-[8px] text-white"
                    type="submit"
                    id="btnRegister"
                    style={{ backgroundColor: ' #F26F27' }}
                  >
                    <Trans>Đăng ký</Trans>
                  </button>
                </div>
                {allow2Oauth === true && (
                  <>
                    <div className={'mx-auto flex justify-center'}>
                      <SocialSignup
                        redirect={
                          query.get('redirect') || DEFAULT_REDIRECT_URI + '/o/0'
                        }
                      />
                    </div>
                  </>
                )}

                <div className="flex gap-x-1 text-center w-full justify-center items-center mt-2">
                  <div className="text-[14px] text-white">
                    <Trans>Bạn đã có tài khoản?</Trans>
                  </div>
                  <div>
                    <Link
                      to={`/login${
                        redirectParam ? `?redirect=${redirectParam}` : ''
                      }`}
                    >
                      <div className="text-white text-[14px] underline font-medium ">
                        <Trans>Nhấn vào đây để đăng nhập</Trans>
                      </div>
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonalForm;
